import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list"]
  static values = {
    questionId: Number,
    submitUrl: String
  }

  connect() {
    this.submitted = false
    this.sortable = Sortable.create(this.listTarget, { animation: 150 })
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  async submit() {
    if (this.submitted) return
    this.submitted = true

    const ordered = Array.from(this.listTarget.children).map((li) => li.dataset.itemId)

    try {
      const response = await fetch(this.submitUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          question_id: this.questionIdValue,
          payload: { ordered: ordered }
        })
      })
      if (!response.ok) throw new Error(`Submit failed: ${response.status}`)
      this.element.classList.add("opacity-50", "pointer-events-none")
    } catch (error) {
      console.error("Ranking submit failed:", error)
      this.submitted = false
    }
  }
}
